import { LowerRegions } from '@/modules/configs/region'

/**
 *
 * @param baseHref should start with `/`
 */
export const getRegionalHref = (baseHref: string, region: LowerRegions) => {
  if (region === 'global') return baseHref
  return `/${region}${baseHref}`
}
